// src/components/MediaCarousel.jsx
import React, { useRef } from "react";

export default function MediaCarousel({ items = [], onSelect }) {
  const scrollerRef = useRef(null);

  const scrollByPx = (px) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: px, behavior: "smooth" });
  };

  return (
    <div className="relative">
      {/* Left button */}
      <button
        type="button"
        aria-label="Scroll left"
        onClick={() => scrollByPx(-320)}
        className="absolute -left-3 top-1/2 -translate-y-1/2 z-10 rounded-full border border-neutral-300 bg-white/90 backdrop-blur px-3 py-2 shadow hover:bg-white"
      >
        ‹
      </button>

      {/* Scroller */}
      <div
        ref={scrollerRef}
        className="hide-scroll flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2"
        style={{ scrollSnapType: "x mandatory" }}
      >
        {/* hide scrollbar (webkit) */}
        <style>{`.hide-scroll::-webkit-scrollbar{display:none}`}</style>

        {items.map((m) => (
          <button
            key={m.id}
            type="button"
            onClick={() => onSelect?.(m)}
            className="min-w-[260px] snap-start relative group"
            title={m.alt || m.name || "media"}
          >
            {m.type === "video" ? (
              <video
                src={m.src}
                muted
                playsInline
                className="w-[260px] h-[160px] object-cover rounded-xl border border-neutral-200 shadow-sm"
              />
            ) : (
              <img
                src={m.src}
                alt={m.alt || "media"}
                className="w-[260px] h-[160px] object-cover rounded-xl border border-neutral-200 shadow-sm"
              />
            )}

            {/* play badge for videos */}
            {m.type === "video" && (
              <span className="pointer-events-none absolute inset-0 grid place-items-center">
                <span className="opacity-0 group-hover:opacity-100 transition rounded-full bg-black/50 text-white text-xs px-3 py-1">
                  Move to hero
                </span>
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Right button */}
      <button
        type="button"
        aria-label="Scroll right"
        onClick={() => scrollByPx(320)}
        className="absolute -right-3 top-1/2 -translate-y-1/2 z-10 rounded-full border border-neutral-300 bg-white/90 backdrop-blur px-3 py-2 shadow hover:bg-white"
      >
        ›
      </button>
    </div>
  );
}
